export default __webpack_public_path__ + "static/media/835.ca838380.gif";